import { useEffect, useState } from "react";

interface FaqItem {
  question: string;
  answer: string;
}

interface FaqStep {
  id: string;
  title: string;
  questions: FaqItem[];
}

interface FaqData {
  faqSteps: FaqStep[];
}

export const useFaqData = () => {
  const [faqSteps, setFaqSteps] = useState<FaqStep[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadFaqData = async () => {
      try {
        const response = await fetch("/faq-data.json");

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data: FaqData = await response.json();
        setFaqSteps(data.faqSteps);
      } catch (err) {
        const errorMessage =
          err instanceof Error ? err.message : "Erro ao carregar FAQ";
        console.error("Error loading FAQ data:", err);
        setError(errorMessage);
      } finally {
        setIsLoading(false);
      }
    };

    loadFaqData();
  }, []);

  return { faqSteps, isLoading, error };
};
